import $ from "jquery";
import State from "../modules/state";

const $eventhub = $(document);
const state = new State({}, $eventhub);
const events = state.getEvents();
const store = {
	$eventhub,
	state,
	events
};

export default store;

window.store = store;


// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/store.js